import script from "./RadioGroupField.vue?vue&type=script&setup=true&lang=js"
export * from "./RadioGroupField.vue?vue&type=script&setup=true&lang=js"

import "./RadioGroupField.vue?vue&type=style&index=0&id=8320ef48&scoped=true&lang=css"

import exportComponent from "/home/dragos/Work/cozmoslabs-ddev/translatepress/wp-content/plugins/translatepress/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8320ef48"]])

export default __exports__